module.exports = __webpack_public_path__ + "img/plum-logo-colapsed.c3084875.svg";